<template>
  <div class="home-page">
    <div class="top-nav">
      <div class="top-nav-left" @click="$parent.goNav('/')">
        <img :src="$store.state.appInfo.site_logo" alt="Logo" class="logo-img" />
      </div>
      <div class="top-nav-middle">
        <h1 class="page-title">{{ $store.state.appInfo.title }}</h1>
      </div>
      <div class="top-nav-right">
        <button class="top-nav-btn" @click="$parent.goNav('/kefu')">
          <i class="btn-icon fas fa-comment"></i>
          <span class="btn-text">客服</span>
        </button>
        <button class="top-nav-btn" @click="$parent.goNav('/myNews')">
          <i class="btn-icon fas fa-bullhorn"></i>
          <span class="btn-text">公告</span>
        </button>
      </div>
    </div>
    <div class="appbox" v-if="showAppDownload && !isAppBoxClosed">
      <img class="close-btn" @click="closeAppBox" src="/static/image/hongbaocolse.png" alt="关闭按钮" />
      <img class="logo" v-if="$store.state.appInfo.site_logo" :src="$store.state.appInfo.site_logo" alt="应用logo" />
      <img class="logo" v-else src="/static/image/app-logo.png" alt="默认logo" />
      <div class="text-content">
        <div class="title">{{ $store.state.appInfo.title }}app</div>
        <div class="description">真人娱乐，体育投注，电子游艺等尽在一手掌握</div>
      </div>
      <van-button type="info" class="download-btn" @click="$parent.goNav('/app')">立即下载</van-button>
    </div>
    <div 
      class="floating-redpacket" 
      v-if="$store.state.appInfo.redpacket_switch == 1 && redpacketShow"
      @click="$parent.goNav('/hongbao')"
    >
      <i class="fas fa-red-envelope"></i>
      <span class="redpacket-text">红包福利</span>
      <img 
        src="/static/image/close_popup.png" 
        class="close-icon" 
        @click.stop="closeRedpacket"
        alt="关闭红包图标"
      />
    </div>
    <div 
      class="popup-background" 
      v-if="$store.state.appInfo.index_modal == 1" 
      v-show="isPopupShow"
    >
      <div class="safety-tip">
        <i class="close fas fa-times" @click="closePopup"></i>
        <div class="title">欢迎来到{{ $store.state.appInfo.title }}</div>
        <div class="unbind-box" v-html="$store.state.appInfo.webcontent"></div>
        <div class="auto-close-countdown">弹窗将在 {{ countdown }} 秒后自动关闭</div>
      </div>
    </div>
    <div class="container">
      <div class="banner-container">
        <div class="swiper" ref="bannerSwiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
              <img :src="item.src" alt="Banner图片" class="banner-img" />
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
      <div class="notice-marquee">
        <span class="notice-label">公告</span>
        <div class="marquee-inner">
          <ul class="notice-list">
            <li class="notice-item" v-for="(item, index) in homenoticelis" :key="index">{{ item }}</li>
          </ul>
        </div>
      </div>
      <div class="user-operation-bar">
        <div class="user-info">
          <div class="avatar" @click="handleAvatarClick">
            <img :src="$store.state.userInfo.avatar || '/static/image/ava.svg'" alt="用户头像" class="avatar-img" />
          </div>
          <div 
            class="user-name" 
            @click="handleUserNameClick"
            :class="{ 'user-name--logged': $store.state.userInfo.realname }"
          >
            {{ $store.state.userInfo.realname || '立即登录' }}
          </div>
          <div class="user-balance" @click="handleBalanceClick">余额: {{ $store.state.userInfo.balance || '0.00' }}</div>
        </div>
        <div class="operation-buttons">
          <button class="op-btn" @click="handleDepositClick"><i class="fas fa-coins"></i>充值</button>
          <button class="op-btn" @click="handleWithdrawClick"><i class="fas fa-arrow-circle-down"></i>取款</button>
          <button class="op-btn" @click="handleTransferClick"><i class="op-icon fas fa-exchange-alt"></i>转账</button>
          <button class="op-btn" @click="handleOrderClick"><i class="fas fa-receipt"></i>注单</button>
        </div>
      </div>
      <div class="main-content">
        <div class="game-cate-container">
          <div class="game-cate-btns">
            <button 
              class="cate-btn" 
              v-for="(cate, index) in gameCateList" 
              :key="index"
              @click="activeCate = index"
              :class="{active: activeCate == index}"
            >
              <div class="cate-icon" :style="{background: cate.color}"><i :class="cate.icon"></i></div>
              <span class="cate-name">{{ cate.name }}</span>
            </button>
          </div>
        </div>
        <div class="game-scroll-wrap">
          <div class="game-scroll" ref="gameScroll">
            <div class="game-card" 
                 v-for="(item, index) in currentGameList" 
                 :key="index" 
                 @click="handleGameCardClick(item)"
            >
              <div class="card-name">{{item.name}}</div>
              <div class="card-casino">{{item.platform_name}} {{getCategoryLabel(item.category_id)}}</div>	
              <img :src="item.mobile_img || item.api_logo_img" :alt="item.name" class="card-icon"/>
            </div>
            <!-- 加载状态指示器 -->
            <div class="loading-indicator" v-if="isLoading">
              <i class="fas fa-spinner fa-spin"></i> 加载中...
            </div>
            <div class="no-more" v-if="!hasMore && !isLoading">
              已显示全部内容
            </div>
          </div>
          <div class="scroll-hint" v-if="hasMore && !isLoading">向下滑动查看更多</div>
        </div>
        <div class="strength-section" v-if="showStrengthSection">
          <div class="section-header">
            <h3 class="section-title">实力展示</h3>
            <span class="more-link" @click="$parent.goNav('/sponsor')">更多 →</span>
          </div>
          <div class="strength-list">
            <div class="strength-item" v-for="(item, index) in strengthData" :key="index">
              <img :src="item.imgUrl" alt="实力展示图片" class="strength-img" />
              <p class="strength-desc">{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-nav-container">
      <div class="bottom-nav-line"></div>
      <div class="bottom-nav">
        <div class="bottom-nav-item" :class="{active: $route.path == '/activeList'}" @click="$parent.goNav('/activeList')">
          <i class="nav-icon fas fa-gift"></i>
          <span class="nav-text">优惠</span>
        </div>
		<div class="bottom-nav-item" :class="{active: $route.path == '/kefu'}" @click="$parent.goNav('/kefu')">
		  <i class="nav-icon fas fa-comments"></i>
		  <span class="nav-text">客服</span>
		</div>
        <div class="bottom-nav-home" :class="{active: $route.path == '/'}" @click="$parent.goNav('/')">
          <div class="home-circle"><i class="home-icon fas fa-home"></i></div>
          <span class="nav-text">首页</span>
        </div>
		<div class="bottom-nav-item" :class="{active: $route.path == '/sponsor'}" @click="$parent.goNav('/sponsor')">
		  <i class="nav-icon fas fa-trophy"></i>
		  <span class="nav-text">赞助</span>
		</div>
        <div class="bottom-nav-item" :class="{active: $route.path == '/userCenter'}" @click="handleBottomMyClick">
          <i class="nav-icon fas fa-user"></i>
          <span class="nav-text">我的</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Main',
  data() {
    return {
      isAppBoxClosed: false,
      homenoticelis: [],
      bannerList: [],
      gameListMap: { realbet: [], gaming: [], concise: [], sport: [], lottery: [], joker: [] },
      activeCate: 0,
      showStrengthSection: true,
      redpacketShow: true,
      isPopupShow: false,
      countdown: 10,
      showCount: 10,        // 初始显示数量
      isLoading: false,     // 加载状态
      loadMoreStep: 10,     // 每次加载数量
      autoCloseTimer: null,
      lastPopupDate: localStorage.getItem('popupLastDate') || '',
      gameCateList: [
        { name: '真人视讯', icon: 'fas fa-microphone-lines', color: '#FF6B6B', id: 'realbet' },  
        { name: '电竞游戏', icon: 'fas fa-trophy', color: '#4ECDC4', id: 'gaming' },  
        { name: '电子游艺', icon: 'fas fa-gamepad', color: '#FFD166', id: 'concise' },  
        { name: '体育竞技', icon: 'fas fa-basketball', color: '#6A0572', id: 'sport' },  
        { name: '彩票投注', icon: 'fas fa-dice', color: '#1A535C', id: 'lottery' },  
        { name: '棋牌游戏', icon: 'fas fa-chess-queen', color: '#2EC4B6', id: 'joker' },  
      ],
      strengthData: [
        { imgUrl: `/static/image/sport/signed_welsh_video_img1-1c0a.jpg`, desc: `${this.$store.state.appInfo.title}收购乐橙娱乐` },
        { imgUrl: `/static/image/sport/sponsor_french_img1-3b78.jpg`, desc: '韦斯利·斯内德正式代言' },
        { imgUrl: `/static/image/sport/Landing-MilanAcademyShenzhen-25-26.png`, desc: '签约卢卡斯·波多尔斯基' }
      ]
    };
  },
  created() {
    this.initData();
    if (this.$store.state.appInfo.index_modal == 1 && this.lastPopupDate !== this.getTodayDate()) {
      this.isPopupShow = true;
      this.startAutoCloseTimer();
    }
  },
  computed: {
    currentGameList() {
      const cateId = this.gameCateList[this.activeCate].id;
      return this.gameListMap[cateId].filter(item => item.app_state == 1).slice(0, this.showCount);
    },
    showAppDownload() {
      return this.$store.state.appInfo.app_enabled === "1";
    },
    // 判断是否还有更多数据
    hasMore() {
      const cateId = this.gameCateList[this.activeCate].id;
      const totalCount = this.gameListMap[cateId].filter(item => item.app_state == 1).length;
      return this.showCount < totalCount;
    }
  },
  methods: {
    getCategoryLabel(categoryId) {
      const labelMap = {
        realbet: 'CASINO',      // 真人
        gaming: 'ESPORTS',      // 电竞
        concise: 'SLOTS GAME',  // 电子
        sport: 'SPORT',         // 体育
        lottery: 'LOTTERY',     // 彩票
        joker: 'BOARD'          // 棋牌
      };
      return labelMap[categoryId] || 'NULL';
    },	  
    closeAppBox() {
      this.isAppBoxClosed = true;
      localStorage.setItem('appBoxClosed', 'true');
      localStorage.setItem('appBoxClosedTime', new Date().getTime().toString());
    },
    initData() {
      this.getGameList();
      this.getNotice();
      this.getBanner();
      const closed = localStorage.getItem('appBoxClosed');
      const closedTime = localStorage.getItem('appBoxClosedTime');
      if (closed === 'true' && closedTime) {
        const now = new Date().getTime();
        if (now - parseInt(closedTime) < 24 * 60 * 60 * 1000) {
          this.isAppBoxClosed = true;
        }
      }
    },
    getGameList() {
      this.$apiFun.get('/api/game/list', { category: '' }).then(res => {
        res.code === 200 && res.data.forEach(el => this.gameListMap[el.category_id].push(el));
      });
    },
    getNotice() {
      this.$apiFun.post('/api/homenotice', {}).then(res => {
        this.homenoticelis = res.code === 200 ? res.data : [];
      });
    },
    getBanner() {
      this.$parent.showLoading();
      this.$apiFun.post('/api/bannerList', { type: 2 }).then(res => {
        this.bannerList = res.code === 200 ? res.data : [];
      }).finally(() => {
        this.$parent.hideLoading();
        this.initSwiper();
      });
    },
    // 统一校验登录状态：从Vuex获取
    checkLogin() {
      const token = this.$store.state.token;
      if (!token) {
        this.$parent.showTost(0, '请登录！');
        $('.mask').fadeOut(300);
        $('.mask.login').fadeIn(300);
        return false;
      }
      return true;
    },
    handleUserNameClick() {
      const hasLogin = !!this.$store.state.userInfo.realname;
      hasLogin ? this.$parent.goNav('/userCenter') : this.$parent.goNav('/login');
    },
    handleBottomMyClick() {
      const hasLogin = !!this.$store.state.userInfo.realname;
      hasLogin ? this.$parent.goNav('/userCenter') : this.$parent.goNav('/login');
    },
    handleAvatarClick() {
      if (!this.checkLogin()) return;
      this.$parent.goNav('/userCenter');
    },
    handleBalanceClick() {
      if (!this.checkLogin()) return;
      this.$parent.goNav('/userCenter');
    },
    handleGameCardClick(item) {
      if (!this.checkLogin()) return;
      this.$parent.goNav(`/gamePage?name=${item.platform_name}&type=${item.game_code}&code=`);
    },
    handleDepositClick() {
      if (!this.checkLogin()) return;
      this.$parent.goNav('/deposit');
    },
    handleWithdrawClick() {
      if (!this.checkLogin()) return;
      this.$parent.goNav('/withdraw');
    },
    handleTransferClick() {
      if (!this.checkLogin()) return;
      this.$parent.goNav('/assets?expandBalance=1');
    },
    handleOrderClick() {
      if (!this.checkLogin()) return;
      this.$parent.goNav('/assets?type=4');
    },
    closeRedpacket() {
      this.redpacketShow = false;
    },
    closePopup() {
      this.clearAutoCloseTimer();
      this.countdown = 10;
      this.isPopupShow = false;
      localStorage.setItem('popupLastDate', this.getTodayDate());
    },
    startAutoCloseTimer() {
      this.clearAutoCloseTimer();
      this.autoCloseTimer = setInterval(() => {
        this.countdown--;
        this.countdown <= 0 && this.closePopup();
      }, 1000);
    },
    clearAutoCloseTimer() {
      this.autoCloseTimer && (clearInterval(this.autoCloseTimer), this.autoCloseTimer = null);
    },
    getTodayDate() {
      const d = new Date();
      return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    },
    getImgSuffix(cateId) {
      const suffixMap = { realbet: '', gaming: '.webp', concise: 'dz', sport: 'ty', lottery: 'cp', joker: 'qp' };
      return suffixMap[cateId] || '';
    },
    getGameListLength() {
      const cateId = this.gameCateList[this.activeCate].id;
      return this.gameListMap[cateId].filter(item => item.app_state == 1).length;
    },
    initSwiper() {
      if (window.Swiper && this.bannerList.length) {
        new Swiper(this.$refs.bannerSwiper, {
          slidesPerView: 1,
          loop: true,
          pagination: { el: '.swiper-pagination', clickable: true },
          autoplay: { 
            delay: 3000, 
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        });
      }
    },
    // 初始化滚动监听
    initScrollListener() {
      const scrollContainer = this.$refs.gameScroll;
      if (scrollContainer) {
        scrollContainer.addEventListener('scroll', this.handleScroll);
      }
    },
    
    // 处理滚动事件
    handleScroll() {
      const scrollContainer = this.$refs.gameScroll;
      if (!scrollContainer || this.isLoading || !this.hasMore) {
        return;
      }
      
      // 判断是否滚动到底部（距离底部小于等于50px）
      const isBottom = scrollContainer.scrollHeight - scrollContainer.scrollTop <= 
                      scrollContainer.clientHeight + 50;
      
      if (isBottom) {
        this.loadMoreData();
      }
    },
    
    // 加载更多数据
    loadMoreData() {
      this.isLoading = true;
      
      // 模拟网络请求延迟
      setTimeout(() => {
        const cateId = this.gameCateList[this.activeCate].id;
        const totalCount = this.gameListMap[cateId].filter(item => item.app_state == 1).length;
        
        // 计算下次显示的数量，不超过总条数
        this.showCount = Math.min(this.showCount + this.loadMoreStep, totalCount);
        this.isLoading = false;
      }, 500);
    },
    
    // 重置加载状态（切换分类时调用）
    resetLoadState() {
      this.showCount = 10;
      this.isLoading = false;
    }
  },
  watch: {
    // 当切换分类时重置加载状态
    activeCate() {
      this.resetLoadState();
    }
  },
  mounted() {
    this.initSwiper();
    // 初始化滚动监听
    this.initScrollListener();
  },
  beforeDestroy() {
    this.clearAutoCloseTimer();
    // 移除滚动监听
    const scrollContainer = this.$refs.gameScroll;
    if (scrollContainer) {
      scrollContainer.removeEventListener('scroll', this.handleScroll);
    }
  }
};
</script>

<style lang="scss" scoped>
// 基础变量
$white: #ffffff;
$light-gray: #f9fafb;
$border-gray: #e5e7eb;
$accent: #165DFF;
$radius: 10px;
$spacing: 12px;
$bottom-nav-height: 60px;
$transition: all 0.3s ease;
.home-page {
  width: 100%;
  min-height: 100vh;
  background: $white;
  padding-bottom: $bottom-nav-height;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}
.top-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 998;
  background: $white;
  border-bottom: 1px solid $border-gray;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  height: 50px;
  .top-nav-left { width: 44px; cursor: pointer; .logo-img { width: 44px; height: 44px; object-fit: contain; } }
  .top-nav-middle {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .page-title { font-size: 18px; color: #1f2937; font-weight: 600; margin: 0; }
  }
  .top-nav-right { display: flex; gap: 8px; }
  .top-nav-btn {
    display: flex;
    align-items: center;
    gap: 4px;
    background: $light-gray;
    border: none;
    border-radius: 20px;
    padding: 5px 12px;
    cursor: pointer;
    font-size: 13px;
    color: #4b5563;
    transition: $transition;
    &:hover { background: $accent; color: $white; transform: translateY(-2px); }
  }
}
.appbox {
  position: fixed;
  top: 50px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  display: flex;
  align-items: center;
  background: white;
  border-radius: 0 0 12px 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 10px 20px;
  width: 90%;
  max-width: 500px;
  animation: slideDown 0.3s ease-out;
  .close-btn {
    width: 12px;
    height: 12px;
    cursor: pointer;
    margin-right: 5px;
    transition: transform 0.2s;
    &:hover { transform: scale(1.1); }
  }
  .logo {
    width: 24px;
    height: 24px;
    margin-right: 15px;
    border-radius: 8px;
    object-fit: cover;
  }
  .text-content {
    flex: 1;
    min-width: 0;
    .title {
      font-size: 16px;
      font-weight: 700;
      color: #1f2937;
      margin-bottom: 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .description {
      font-size: 13px;
      color: #6b7280;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .download-btn {
    background: url(/static/image/btnBg.png) no-repeat !important;
    background-size: 100% 100% !important;
    border: none !important;
    border-radius: 6px !important;
    padding: 8px 16px !important;
    font-size: 14px !important;
    color: white !important;
	height: 0.4rem !important;
    cursor: pointer !important;
    transition: transform 0.2s !important;
    &:hover { transform: translateY(-2px); }
  }
}
.floating-redpacket {
  position: fixed;
  top: 70px;
  right: 20px;
  z-index: 997;
  background: #FF5252;
  color: $white;
  border-radius: $radius;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 16px rgba(255,82,82,0.3);
  cursor: pointer;
  transition: $transition;
  &:hover { transform: translateY(-3px); box-shadow: 0 6px 20px rgba(255,82,82,0.4); }
  .fas { font-size: 18px; }
  .redpacket-text { font-size: 14px; font-weight: 500; }
  .close-icon { width: 16px; height: 16px; cursor: pointer; }
}
.popup-background {
  position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 999;
  background: rgba(0, 0, 0, 0.5); display: flex; align-items: center; justify-content: center;
  padding: 20px; animation: fadeIn 0.3s ease;
  .safety-tip {
    width: calc(100% - 32px); max-width: 450px; padding: 30px; background: $white;
    border-radius: $radius; box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1); position: relative;
    animation: slideUp 0.3s ease;
    .close { position: absolute; top: 16px; right: 16px; cursor: pointer; font-size: 20px; color: #9ca3af; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; border-radius: 50%; &:hover { background: #f3f4f6; color: #6b7280; } }
    .title { font-size: 20px; font-weight: 700; text-align: center; margin-bottom: 20px; color: #111827; padding-bottom: 15px; border-bottom: 1px solid $light-gray; }
    .unbind-box { color: #4b5563; line-height: 1.8; font-size: 15px; padding: 10px 0; }
    .auto-close-countdown { margin-top: 25px; text-align: center; color: #6b7280; font-size: 14px; padding-top: 15px; border-top: 1px solid $light-gray; }
  }
}
@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
@keyframes marquee { 0% { transform: translateX(100%); } 100% { transform: translateX(-100%); } }
@keyframes slideDown { from { opacity: 0; transform: translate(-50%, -100%); } to { opacity: 1; transform: translate(-50%, 0); } }
.container {
  width: calc(100% - 32px); max-width: 1200px; margin: 0 auto; padding-top: 76px;
}
.banner-container { 
  border-radius: $radius; 
  overflow: hidden; 
  margin-bottom: $spacing; 
  .banner-img { width: 100%; height: auto; object-fit: cover; } 
  .swiper-pagination-bullet { 
    width: 8px; height: 8px; background: $white; opacity: 0.6;
    &.active { width: 16px; background: $accent; opacity: 1; } 
  }
}
.notice-marquee {
  background: $light-gray; 
  border-radius: $radius; 
  padding: 8px 16px; 
  display: flex; 
  align-items: center; 
  overflow: hidden; 
  margin-bottom: $spacing;
  border: 1px solid #e0e0e0;
  .notice-label { background: $accent; color: $white; font-size: 12px; padding: 2px 8px; border-radius: 4px; margin-right: 12px; flex-shrink: 0; }
  .marquee-inner { width: 100%; overflow: hidden; }
  .notice-list { display: flex; animation: marquee 20s linear infinite; list-style: none; padding: 0; margin: 0; &:hover { animation-play-state: paused; } }
  .notice-item { margin-right: 40px; white-space: nowrap; color: #4b5563; font-size: 14px; }
}
.user-operation-bar {
  background: $white; border: 1px solid $border-gray; border-radius: $radius; padding: 12px 16px; box-shadow: 0 2px 8px rgba(0,0,0,0.05); margin-bottom: $spacing;
  .user-info { display: flex; align-items: center; gap: 12px; margin-bottom: 12px; }
  .avatar { width: 40px; height: 40px; border-radius: 50%; overflow: hidden; cursor: pointer; &:hover { transform: scale(1.05); } .avatar-img { width: 100%; height: 100%; object-fit: cover; } }
  .user-name { font-size: 15px; color: #1f2937; font-weight: 700; cursor: pointer; &:hover { color: $accent; } &--logged {:hover { color: #0E42C3; } } &:not(&--logged) { color: $accent; font-weight: 600; } }
  .user-balance { margin-left: auto; font-size: 14px; color: #FF5252; font-weight: 600; cursor: pointer; &:hover { color: #E03131; } }
  .operation-buttons { display: flex; gap: 8px; }
  .op-btn { 
    flex: 1; border: none; border-radius: $radius; padding: 8px 0; font-size: 14px; cursor: pointer; 
    display: flex; align-items: center; justify-content: center; gap: 6px; transition: $transition;
    &:nth-child(1) { background: $accent; color: $white; }
    &:nth-child(2) { background: #4CAF50; color: $white; }
    &:nth-child(3) { background: #FF9800; color: $white; }
    &:nth-child(4) { background: #FC0100; color: $white; }
    &:hover { opacity: 0.9; transform: translateY(-2px); }
  }
}

// 游戏分类容器样式
.game-cate-container {
  position: relative;
  
  // 大屏幕下移除渐变指示器
  @media (min-width: 768px) {
    &::after {
      display: none;
    }
  }
  
  // 小屏幕添加渐变指示器，提示用户可以滚动
  @media (max-width: 767px) {
    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 30px;
      background: linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,1));
    }
  }
}
.game-cate-btns {
  display: flex;
  padding: 2px 0 5px;
  width: 100%;
  @media (min-width: 768px) {
    justify-content: center; 
    flex-wrap: wrap; 
    overflow-x: visible;
    white-space: normal;
  }
  @media (max-width: 767px) {
    overflow-x: auto;  // 允许横向滚动
    scrollbar-width: thin;  // 细滚动条
    scrollbar-color: $accent $light-gray;  // 滚动条颜色
    -webkit-overflow-scrolling: touch;  // 平滑滚动
    white-space: nowrap;  // 防止换行
    
    // 隐藏滚动条但保留功能
    &::-webkit-scrollbar {
      height: 4px;
    }
    
    &::-webkit-scrollbar-track {
      background: $light-gray;
      border-radius: 10px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: $accent;
      border-radius: 10px;
    }
  }
}

// 分类按钮样式
.cate-btn {
  min-width: 90px;  // 固定最小宽度
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  background: $light-gray;
  border: none;
  border-radius: $radius;
  padding: 12px 8px;
  cursor: pointer;
  transition: $transition;
  text-align: center;
  @media (max-width: 767px) {
    flex-shrink: 0;
  }
  
  &.active {
    background: $white;
    border: 2px solid $accent;
    color: $accent;
    box-shadow: 0 2px 8px rgba(22,93,255,0.15);
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.08);
  }
  
  .cate-icon {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: $white;
  }
  
  .cate-name {
    font-size: 13px;
    white-space: nowrap;
    font-weight: 500;
  }
}

// 小屏幕额外调整
@media (max-width: 576px) {
  .cate-btn {
    min-width: 80px;  // 小屏幕略小的按钮
    padding: 10px 5px;
  }
  
  .cate-icon {
    width: 32px;
    height: 32px;
    font-size: 16px;
  }
  
  .cate-name {
    font-size: 12px;
  }
}

.game-scroll-wrap {
  background: $white; 
  border: 1px solid $border-gray; 
  border-radius: $radius; 
  padding: 2px; 
  margin-bottom: $spacing; 
  box-shadow: 0 2px 8px rgba(0,0,0,0.05); 
  width: 100%; 
  box-sizing: border-box;
  .game-scroll { 
	  width: 100%; 
	  max-height: 500px; 
	  overflow-y: auto; 
	  scrollbar-width: thin; 
	  &::-webkit-scrollbar { 
		  width: 6px; 
	  } 
	  &::-webkit-scrollbar-thumb { 
		  background: $accent; 
		  border-radius: 10px; 
		} 
	}
.game-card { 
  top:2px;	
  position: relative;
  display: flex; 
  align-items: center; 
  background: $light-gray; 
  border-radius: $radius; 
  padding: 0; 
  margin-bottom: 10px; 
  cursor: pointer; 
  transition: $transition; 
  overflow: hidden;
  height: 120px; 
  
  &:last-child { 
    margin-bottom: 0; 
  } 
  
  &:hover { 
    background: $white; 
    border: 1px solid $accent; 
    transform: translateY(-2px); 
    box-shadow: 0 4px 12px rgba(22,93,255,0.1); 
  } 
  
  .card-icon { 
    width: 100%; 
    height: 100%; 
    object-fit: cover; 
  } 
  .card-name, .card-casino {
    position: absolute;
    color: white; 
    text-shadow: 0 1px 3px rgba(0,0,0,0.7); 
    z-index: 10; 
    padding: 0 8px;
  }
  .card-name {
    color: #444;
    left: 10px;
    font-size: 16px;
    border-radius: 4px;

	font-style: italic;
  }
  .card-casino {  
    bottom: 30px;
    left: 10px;
    font-size: 14px;
    border-radius: 4px;
	font-style: italic;
  }
}

  .scroll-hint { text-align: center; color: #9ca3af; font-size: 12px; padding: 8px 0; }
  
  // 加载状态样式
  .loading-indicator {
    text-align: center;
    padding: 15px;
    color: #6b7280;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
  
  .no-more {
    text-align: center;
    padding: 15px;
    color: #9ca3af;
    font-size: 14px;
  }
}
.strength-section {
  background: $white; border: 1px solid $border-gray; border-radius: $radius; padding: $spacing; margin-bottom: $spacing; width: 100%; box-sizing: border-box;
  .section-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: $spacing; }
  .section-title { font-size: 16px; font-weight: 600; color: #1f2937; margin: 0; }
  .more-link { font-size: 13px; color: $accent; cursor: pointer; &:hover { color: #0E42C3; } }
  .strength-list { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; }
  .strength-item { background: $light-gray; border-radius: $radius; overflow: hidden; padding: 10px; transition: $transition; &:hover { transform: translateY(-3px); box-shadow: 0 4px 8px rgba(0,0,0,0.08); } .strength-img { width: 100%; height: 70px; object-fit: cover; border-radius: 6px; margin-bottom: 8px; } .strength-desc { font-size: 13px; color: #4b5563; margin: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; } }
}
.bottom-nav-container {
  position: fixed; bottom: 0; left: 0; right: 0; z-index: 998;
  .bottom-nav-line { position: absolute; bottom: $bottom-nav-height; left: 0; right: 0; height: 2px; background: $border-gray; z-index: 1; }
  .bottom-nav { position: relative; height: $bottom-nav-height; background: $white; border-top: 1px solid $border-gray; display: flex; align-items: center; justify-content: space-around; padding: 0 16px; box-shadow: 0 -2px 8px rgba(0,0,0,0.05); z-index: 2; }
}
.bottom-nav-item {
  display: flex; flex-direction: column; align-items: center; justify-content: center; color: #4b5563; cursor: pointer; transition: $transition; padding: 8px 0; flex: 1; max-width: 80px;
  &.active, &:hover { color: $accent; }
  .nav-icon { font-size: 20px; margin-bottom: 4px; }
  .nav-text { font-size: 12px; font-weight: 500; }
}
.bottom-nav-home {
  display: flex; flex-direction: column; align-items: center; justify-content: center; color: $accent; cursor: pointer; flex: 1; max-width: 80px; margin-top: -20px;
  .home-circle { width: 50px; height: 50px; border-radius: 50%; background: $white; border: 2px solid $accent; display: flex; align-items: center; justify-content: center; margin-bottom: 4px; box-shadow: 0 4px 8px rgba(22,93,255,0.2); .active & { background: $accent; } }
  .home-icon { font-size: 24px; color: $accent; .active & { color: $white; } }
  .nav-text { font-size: 12px; font-weight: 500; margin-top: 2px; }
}
@media (max-width: 576px) {
  .top-nav .btn-text, .strength-section .more-link { display: none; }
  .top-nav .top-nav-btn { padding: 5px 10px; gap: 0; }
  .top-nav .page-title { font-size: 16px; }
  .bottom-nav-home { margin-top: -18px; }
  .home-circle { width: 46px; height: 46px; }
  .home-icon { font-size: 22px; }
  .bottom-nav-item .nav-icon { font-size: 18px; }
  .bottom-nav-item .nav-text { font-size: 11px; }
  .strength-list { grid-template-columns: repeat(2, 1fr); }
  .game-card { padding: 10px; gap: 8px; }
  .card-icon { width: 40px; height: 40px; }
  .container { width: calc(100% - 24px); padding-top: 10px; }
  .appbox {
    padding: 8px 15px;
    .logo {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
    .text-content .title {
      font-size: 14px;
    }
    .text-content .description {
      font-size: 12px;
    }
    .download-btn {
      padding: 6px 12px !important;
      font-size: 13px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/index.vue